import { connect } from 'react-redux'

import GroupPanel from './groupPanel'

const mapStateToProps = (state, ownProps) => {
  const { layout: { isSidebarOpen } } = state
  return { isSidebarOpen }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const GroupPanelContainer = connect(mapStateToProps, mapDispatchToProps)(
  GroupPanel
)

export default GroupPanelContainer
